import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import App from "./App";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme";
import { BrowserRouter } from "react-router-dom";
import "./Style/Theme/index.css";
import Footer from "./components/common/Footer";
import { RecoilRoot } from "recoil";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RecoilRoot>
        <div style={{ padding: 0, margin: 0 }}>
          {" "}
          <App />
          {/* <Footer /> */}
        </div>
      </RecoilRoot>
    </ThemeProvider>
  </BrowserRouter>
);
